<div class="ui-kit-block-title">
  <code>ui-kit-content-container</code><br />
  Блок, обычно использующийся как контейнер для основного содержимого страницы
</div>
<div class="ui-kit-content-container">
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
</div>

<br />
<br />
<br />

<div class="ui-kit-block-title">
  <code>ui-kit-content-container--with-separators</code><br />
  Блок с горизонтальными разделителями между блоками, обычно использующийся как контейнер для
  основного содержимого страницы. Разделители идут до предпоследнего элемента, т.к. заточено под
  стандартный для проекта дизайн с кнопками снизу
</div>
<div class="ui-kit-content-container--with-separators">
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
</div>

<br />
<br />
<br />

<div class="ui-kit-block-title">
  <code>ui-kit-bottom-buttons-block</code><br />
  Контейнер для кнопок со стандартными для проекта отступами
</div>
<div class="ui-kit-content-container--with-separators">
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
  <div>
    Перед обращением в техническую поддержку, пожалуйста, ознакомьтесь с инструкциями и часто
    возникающими вопросами. Техническая поддержка осуществляется пн.-пт. с 09:00 до 19:00, сб.-вс. с
    09:00 до 15:00 по электронной почте
  </div>
  <div class="ui-kit-bottom-buttons-block">
    <button class="back-button" translate>button.back</button>
    <button class="button_blue" translate>button.save</button>
  </div>
</div>

<br />
<br />
<br />

<div class="ui-kit-block-title">
  <code>ui-kit-centering-string</code><br />
  Блок для центрирования содержимого
</div>
<div class="ui-kit-content-container">
  <div class="ui-kit-centering-string">
    <tax-icon name="pause"></tax-icon>
    я текст кнопки
  </div>
</div>

<br />
<br />
<br />

<div class="ui-kit-block-title">
  <code>ui-kit-block-title</code><br />
  Заголовок какого-либо блока
</div>
<div class="ui-kit-content-container">
  <div class="ui-kit-block-title">я текст кнопки</div>
  Я просто текст
</div>

<div class="ui-kit-block-title">Другие служебные классы</div>
<div class="ui-kit-content-container">
  <div class="ui-kit-grey-text">ui-kit-grey</div>
  <div class="ui-kit-green-text">ui-kit-green-text</div>
  <div class="ui-kit-error-text">ui-kit-error-text</div>
</div>
